<script setup>
import { computed, ref } from 'vue';
import { __ } from '@/utils'
import Modal from "@components/modal.vue";

const isOpen = ref(true);

const emit = defineEmits(['payment']);
const props = defineProps(['debt']);

const handlePayment = () => {
	isOpen.value = false;
	emit('payment');
};

const cleanDebtValue = computed(() => {
	if(!props.debt) {
		return 0;
	}
	return props.debt.replace(/[^0-9.-]+/g,"");
});

</script>

<template>
	<Modal :isActive="isOpen" @close="isOpen = false" class="popup--small modal-error">
		<template #body>
			<img :src="`${theme_path.url}/resources/images/svg/icon-notice.svg`" alt="Fail">
			<h4 class="fz26">
				<strong>{{ __('There is a debt under this account.') }}</strong>
			</h4>
			<p class="fz16">{{ __('The debt is for a total of') }} <span>{{ cleanDebtValue }} ₪</span> {{ __("but don't worry, payment can be arranged quickly and easily.") }}</p>
			<button type="button" class="btn w160" @click="handlePayment">{{ __('to arrange the payment') }}</button>
		</template>
	</Modal>
</template>